import React from "react";

function ITprojectHead() {
    return (
        <>
            <section className="page-header" style={{ backgroundImage: 'url(assets/img/page-banner.jpg)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
                <div className="container">
                    <div className="page-header-info">
                        <h2>
                            <span>IT Projects</span>
                        </h2>
                    </div>
                </div>
            </section>

        </>
    )
}

export default ITprojectHead;